<template>
  <div class="card_field" :class="[widthType]">
    <div class="card_filed_con" :class="{ [statusClass]: true }">
      <p class="card_input_label">
        {{ label }}
        <slot name="icon"></slot>
      </p>
      <slot name="input"></slot>
      <slot name="statusIcon">
        <img
          class="card_show cardok"
          v-if="statusClass == 'success' || statusClass == 'green'"
          src="@img/icon_primer_ok.png"
        />
      </slot>
    </div>
    <p class="errortext" v-show="errorText != ''">{{ errorText }}</p>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  name: 'CardFieldWrap',
  props: {
    widthType: {
      type: String,
      default: 'fullwidth', // halfwidth, fullwidth
      validator: function (value) {
        return ['halfwidth', 'fullwidth'].indexOf(value) !== -1
      },
    },
    label: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    statusClass: {
      type: String,
      default: '',
      validator: function (value) {
        return ['error', 'success', 'info', 'blue', 'red', 'green', ''].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {}
  },
  // 组件方法
  methods: {},
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../cardField.less';
</style>
<style lang="less" scoped></style>
